import React, { useEffect, useState } from 'react';
import './style.css';
import logo from '../../assets/logo2.png';
import { useNavigate } from 'react-router-dom';
import { PaystackButton } from "react-paystack";
import axios from 'axios';
import { message, Result, Button, Layout, ConfigProvider, Card, Alert, Input, Typography, Space, Divider } from "antd";
import { WarningFilled, UserOutlined, CreditCardFilled, ArrowLeftOutlined } from "@ant-design/icons";
import API_ENDPOINTS from '../../Endpoints/environment';
import PaystackVerification from './dashboard/Verify_payment';

const { Content } = Layout;
const { Title, Text } = Typography;

const ApplicationCheck = () => {
  const [applicationNumber, setApplicationNumber] = useState('');
  const navigate = useNavigate();
  const publicKey = API_ENDPOINTS.PAYSTACK_PUBLIC_KEY;
  const amount = 300000;
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [view, setView] = useState('form'); // 'form', 'acceptance', 'dashboard', 'notFound'
  const [paymentReference, setPaymentReference] = useState(null);

  useEffect(() => {
    if (view !== 'acceptance' || paymentReference || !applicationNumber?.id) {
      return;
    }
    axios
      .post(API_ENDPOINTS.PAYMENTS_INITIATE, {
        pay_type: 'acceptance_fees',
        amount,
        personal_detail_id: applicationNumber.id,
        metadata: { phone, id: applicationNumber.id },
      })
      .then((res) => setPaymentReference(res.data.reference))
      .catch((error) => {
        console.error('Error preparing payment reference:', error);
        message.error('Could not prepare payment. Please try again.');
      });
  }, [view, paymentReference, applicationNumber, amount, phone]);

  const componentProps = {
    email,
    amount,
    reference: paymentReference,
    metadata: {
      phone,
      id: applicationNumber.id,
      pay_type: "acceptance_fees",
    },
    ...(API_ENDPOINTS.ENABLE_SPLITS && {
      split: {
        type: "flat",
        subaccounts: [
          // Daniel Alamba
          { subaccount: "ACCT_1hli5sgrrcfuas9", share: 41000 },
          // COE ACCOUNT
          { subaccount: "ACCT_aan2ehxiej239du", share: 200000 },
        ],
      },
    }),
    publicKey,
    text: "Pay Now",
    onSuccess: async (reference) => {
      const paidOn = new Date();
      const formData = {
        application_reference: reference.reference,
        email: email,
        application_date: paidOn.toISOString().split('T')[0],
      };

      localStorage.setItem('UserData', JSON.stringify(formData));
      localStorage.setItem('app_number', applicationNumber);

      try {
        await axios.put(`${API_ENDPOINTS.PERSONAL_DETAILS}/${applicationNumber.id}`, {
          application_reference: reference.reference,
          application_date: paidOn.toISOString().split('T')[0],
        });
      } catch (error) {
        console.error("Fallback update failed, webhook will handle it:", error);
      }

      window.location.href = `/dashboard/${applicationNumber.id}/acceptance-receipt`;
    },
    onClose: () => alert("Wait! Don't leave :("),
  };
  const handleInputChange = (e) => {
    setApplicationNumber(e.target.value);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const back = () => {
    setView('form')
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const hide = message.loading("Checking student details...", 0); // Display a loading indicator

    try {
      const response = await axios.post(`${API_ENDPOINTS.STUDENT_CHECK}`, {
        application_number: applicationNumber,
      });

      if (response.status === 200) {
        hide();
        if (response.data.matric_number) {
          // Student has matric number, redirect to dashboard
          localStorage.setItem("id", response.data.id);
          console.log("Student ID:", response);
          message.success("Student found! Redirecting to dashboard...");
          navigate(`/dashboard/${response.data.id}`);
        } else if (response.data.message === "acceptance") {
          // Student found but acceptance fee is required
          hide();
          message.success("Student found! Redirecting to Acceptance...");
          console.log("Student Details:", response);
          setApplicationNumber(response.data.user)
          setEmail(response.data.user.email)
          setView("acceptance"); // Show acceptance fee prompt
        } else if (response.data.message === "pending") {
          // Pending admission: backend now returns 200 with a user payload
          // (was 425 previously). Keep the existing pending view.
          message.warning("Student admission is pending.");
          setView("pending");
        }
      } else if (response.status === 425) {
        // Legacy path: older backends still return 425 for pending. Keep
        // handling it for backward compatibility while clients deploy.
        hide();
        message.warning("Student admission is pending.");
        setView("pending");
      }
    } catch (error) {
      hide();

      if (error.response) {
        const { status, data } = error.response;

        if (status === 404) {
          // Handle 404 (not found)
          message.warning("Student not found. Proceeding to fee payment.");

        } else if (data.message === "pending") {
          // Handle pending response
          message.info("Student admission is pending.");
          setView("pending");
        } else {
          // Handle unexpected backend errors
          console.error("Error checking student details:", error);
          message.error("An unexpected error occurred. Please try again later.");
        }
      } else {
        // Handle network or unexpected errors
        console.error("Error checking student details:", error);
        message.error("A network error occurred. Please try again later.");
      }
    }

  };


  return (
    <div className="application-check-container">
      <div className="application-card">
        <div className="card-header">
          <img src={logo} width="80px" alt="Logo" className="logo" />
          <Title level={3} style={{marginBottom: '0', marginTop: '0'}} className="text-center text-green ">College of Education Study Centre</Title>
        </div>

        <div className="card-content">
          {view === 'form' && (
            <Space direction="vertical" size="medium" style={{ width: '100%' }}>
              <form onSubmit={handleSubmit} style={{  marginBottom:'2%', marginTop:'0%'}} className="application-form">
                <div className="form-group">
                  <label htmlFor="applicationNumber">Application Number/Matric Number</label>
                  <Input
                    size="large"
                    id="applicationNumber"
                    value={applicationNumber}
                    onChange={handleInputChange}
                    placeholder="Enter your application number or Matric Number"
                    required
                  />
                </div>
                <Button type="primary" htmlType="submit" block size="large" className="btn-green">
                  Continue
                </Button>
              </form>
              
              <Alert
                message="Important Information"
                description="New Applicants should input their Application Number, returning students should input their Matriculation Number"
                type="info"
                showIcon
                className="info-alert"
              />
            </Space>
          )}

          {view === 'acceptance' && (
            <div className="acceptance-view">
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Card className="acceptance-card">
                  <Title level={4} className="text-green">Acceptance Fee Payment</Title>
                  <Text>
                    Congratulations! You have been offered admission to study <b>{applicationNumber.course}</b>
                  </Text>
                  <Text>
                    Please proceed to pay your acceptance fee of ₦3,000 to continue with application and registration
                  </Text>
                  
                  <Divider />
                  
                  <Space direction="vertical" size="small">
                    <Text strong>Student Details:</Text>
                    <Text>Name: {applicationNumber.other_names}</Text>
                    <Text>Application Number: {applicationNumber.application_number}</Text>
                    <Text>Email: {applicationNumber.email}</Text>
                  </Space>

                  <div className="action-buttons">
                    <Button 
                      icon={<ArrowLeftOutlined />} 
                      onClick={back}
                      className="back-button"
                    >
                      Back
                    </Button>
                    {paymentReference ? (
                      <PaystackButton className='btn btn-green' {...componentProps} />
                    ) : (
                      <Button type="primary" loading disabled className="btn-green">
                        Preparing payment…
                      </Button>
                    )}
                  </div>
                </Card>
              </Space>
            </div>
          )}

          {view === 'pending' && (
            <div className="pending-view">
              <Card className="pending-card">
                <Result
                  icon={<WarningFilled className="icon-style" />}
                  title={
                    <Title level={3} className="title-text">
                      Admission Status: Not Offered
                    </Title>
                  }
                  subTitle={
                    <Text className="subtitle-text">
                      We regret to inform you that you have not been offered admission yet. However, keep checking for updates, as statuses may change over time.
                    </Text>
                  }
                  extra={
                    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                      <Button type="primary" block onClick={() => window.location.reload()}>
                        Refresh Status
                      </Button>
                      <Button block onClick={() => console.log("Contact Support")}>
                        Contact Support
                      </Button>
                    </Space>
                  }
                />
              </Card>
            </div>
          )}

          {view === 'verification' && (
            <Layout>
              <Content className="verification-content">
                <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
                  Payment Verification
                </Title>

                <PaystackVerification
                  userEmail={email}
                  id={applicationNumber.id}
                  applicationNumber={applicationNumber}
                />

                <Text type="secondary" className="verification-info">
                  Please enter the reference code from your payment receipt and the amount you paid.
                </Text>
              </Content>
            </Layout>
          )}
        </div>

        <div className="card-footer">
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Text>New to the portal?</Text>
            <Button 
              type="primary" 
              block 
              onClick={() => navigate('/registration')}
              className="register-button"
            >
              Register Now
            </Button>
            <Button
              icon={<CreditCardFilled />}
              onClick={() => navigate('/payment-recovery')}
              block
            >
              Verify / Recover Payment
            </Button>
            <Button
              icon={<UserOutlined />}
              onClick={() => navigate('/admin/login')}
              block
              className="admin-button"
            >
              Staff login
            </Button>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ApplicationCheck;
